<template>
  <v-container fluid fill-height>
    <v-row class="text-center" id="top">
      <v-col cols="12">
        <h1>잘못된 접근입니다. </h1>
        <h2 class="text-lg-h5 mt-3"><router-link route to="/">처음</router-link>으로 돌아가세요.</h2>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  metaInfo: {
    title: '404',
    titleTemplate: '%s | Every Formula',
  },
}
</script>